import {aws, deployments, globalStores as stores, ui} from '@stores'
import {action, computed} from 'mobx'

export const DEFAULT_FONTS = {
  VIP: 'roboto-regular.ttf',
  Assortment: 'roboto-regular.ttf',
  'Avenir Next': 'AvenirNextLTPro-Regular.otf'
}

export class AppStore {

  @computed get workspaceTitle() {
    const {flexLayout: {activeTab}, workspaces, workspaces: {deploymentConfig}} = stores

    return activeTab?.displayName ?? workspaces?.workspaceConfig?.title ?? deploymentConfig?.version
  }

  @computed get detailsTitle() {
    const {sidebar, catalog} = stores,
      right = sidebar?.right

    return !catalog || !right
           ? null
           : right?.open && right?.details?.data ? _.get(right?.details.data, catalog.dataMap.title) : null
  }

  @computed get pageTitle() {
    const {workspaceTitle, detailsTitle} = this, {deployments: {deploymentConfig}} = stores
    return !workspaceTitle ? (deploymentConfig?.title ?? ui.settings.defaultProductName) : `${workspaceTitle}${detailsTitle ? ` - ${detailsTitle}` : ''} (${deploymentConfig?.title ?? ui.settings.defaultProductName})`
  }

  @computed get fonts(): Record<string, string> {
    const {deployments: {deploymentConfig}} = stores
    return _.merge(
      {},
      DEFAULT_FONTS,
      deploymentConfig?.settings?.fonts
    )
  }

  @computed get fontFaces() {
    const {fonts} = this
    return _.keys(fonts).map(k => `@font-face {
                    font-family: '${k}';
                    font-display:swap;
                    src: url('${aws.fontUrlFor(_.trimStart(fonts[k], '/'))}');
                }`).join('\n')
  }

  @computed get appAttributes() {
    const {site, workspaces: {deploymentConfig}, flexLayout: {isMaximized, maximizedTab}} = stores

    return {
      'data-blueprint-loaded': site?.blueprintCssLoaded === true,
      'data-prod': (deployments.selectedDeployment?.tags ?? []).some(t => t == 'prod' || t == 'production'),
      'data-debug': DEBUG,
      'data-deployment': DEBUG ? deployments.selectedDeploymentId : undefined,
      'data-client': deploymentConfig?.customer?.name,
      'data-maximized': isMaximized,
      'data-modal-open': isMaximized && maximizedTab?.catalogRoot?.storesToInject?.sidebar?.right?.isShowingModal,
      'data-left-sidebar-open': maximizedTab?.catalogRoot?.stores?.sidebar?.left?.open,
      'data-right-sidebar-open': maximizedTab?.catalogRoot?.stores?.catalog?.settings?.detailLoc != 'modal' && maximizedTab?.catalogRoot?.stores?.sidebar?.right?.open,
      'data-showing-aggregation-details-sidebar': isMaximized && maximizedTab?.catalogRoot?.catalog?.aggregation?.isShowingAggregateDetails && maximizedTab?.catalogRoot?.catalog?.aggregation?.aggregateLocation == 'sidebar',
      'data-splitter': true,
      'data-pdf-open': isMaximized && maximizedTab?.catalogRoot?.catalog?.isShowingClientPDF,
      'data-right-sidebar-variant': maximizedTab?.catalogRoot ? maximizedTab.catalogRoot.catalog.settings.detailLoc === 'modal' ? 'modal' : maximizedTab?.catalogRoot?.stores?.sidebar?.right?.variant : maximizedTab?.catalogRoot?.stores?.sidebar?.right?.variant,
      'data-touch': site?.touchDevice
    }
  }

  @computed get appStyles() {
    const {site} = stores

    return {
      '--top-bar-height': !site ? undefined : `${site.sizes.topBar.height}px`,
      '--site-header-height': `${Math.max(44, !site ? undefined : site.sizes.siteHeader.height)}px`,
      '--filter-chips-height': !site ? undefined : `${site.sizes.filterChips.height}px`
    } as any
  }
}

export const appStore = new AppStore()


// WEBPACK FOOTER //
// ./src/stores/app/AppStore.ts